import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const ProfileOffersDesktop = loadable(() => import("./ProfileOffersDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <ProfileOffersDesktop {...props} />
  </ErrorBoundary>
);
